import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales/i18n'
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElDialog, ElCarousel, ElCarouselItem, ElDrawer  } from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App);
app.use(i18n)
app.use(router)
app.use(store)
app.component(ElDialog.name, ElDialog)
app.component(ElDropdown.name, ElDropdown)
app.component(ElDropdownMenu.name, ElDropdownMenu)
app.component(ElDropdownItem.name, ElDropdownItem)
app.component(ElCarousel.name, ElCarousel)
app.component(ElCarouselItem.name, ElCarouselItem)
app.component(ElDrawer.name, ElDrawer)
app.mount('#app')